"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ColorPopover;
var _react = _interopRequireDefault(require("react"));
var _Highlight = require("../../constants/Highlight");
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _styles = _interopRequireDefault(require("../ColorPopover/styles"));
var _Highlight2 = _interopRequireDefault(require("../../api/Highlight"));
var _Auth = require("../../contexts/Auth");
var _Trackings = _interopRequireDefault(require("../../services/Trackings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ColorPopover(_ref) {
  var {
    highlight,
    setHighlight,
    onUpdate
  } = _ref;
  var classes = (0, _styles.default)();
  var {
    auth
  } = (0, _Auth.useAuth)();
  var {
    applicationToken,
    sessionToken,
    uuid,
    bookTitle
  } = auth;
  var tracking = (0, _Trackings.default)(auth);
  function onUpdateHighlight(_x) {
    return _onUpdateHighlight.apply(this, arguments);
  }
  function _onUpdateHighlight() {
    _onUpdateHighlight = _asyncToGenerator(function* (highlight) {
      setHighlight();
      var payload = {
        color: highlight.color,
        annotation: highlight.annotation
      };
      var data = yield _Highlight2.default.update(applicationToken, sessionToken, highlight.id, payload);
      var newHighlight = _objectSpread(_objectSpread({}, data), highlight);
      onUpdate(newHighlight);
      tracking.trackColorHighlightEdit({
        uuid,
        titleCover: bookTitle,
        color: newHighlight.color,
        id: newHighlight.id,
        highlight: newHighlight.text_highlighted
      });
    });
    return _onUpdateHighlight.apply(this, arguments);
  }
  return /*#__PURE__*/_react.default.createElement(_saraivaUi.Dialog, {
    handleClose: () => setHighlight(),
    handleConfirm: () => setHighlight(),
    primaryButton: "FECHAR",
    title: "Alterar Cor",
    size: "xs",
    open: Boolean(highlight),
    confirmWithoutCheck: () => setHighlight()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, Object.values(_Highlight.COLOR).filter(item => item.id !== (highlight === null || highlight === void 0 ? void 0 : highlight.color)).map((item, index) => /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
    key: index,
    label: item.label,
    backgroundColor: item.hex,
    onClick: () => onUpdateHighlight(_objectSpread(_objectSpread({}, highlight), {}, {
      color: item.id
    }))
  }))));
}